import * as joint from '@joint/core';
import { FlowPreviewOptions } from './types';
import { applyGraphBackCompatAndCleanup } from './graph-compat';

export class FlowPreview {
    private readonly namespace = joint.shapes;
    private paper: joint.dia.Paper;
    private graph: joint.dia.Graph;

    constructor(options: FlowPreviewOptions) {
        this.graph = new joint.dia.Graph({}, { cellNamespace: this.namespace });

        this.paper = new joint.dia.Paper({
            el: options.container,
            model: this.graph,
            width: options.container.offsetWidth,
            height: options.container.offsetHeight,
            interactive: false,
            cellViewNamespace: this.namespace,
        });

        this.paper.model.fromJSON(JSON.parse(options.graphJson), { cellNamespace: this.namespace });
        // Apply the same backward compatibility and cleanup logic used by FlowEditor
        applyGraphBackCompatAndCleanup(this.graph);
        this.paper.model.fromJSON(this.graph.toJSON(), { cellNamespace: this.namespace });
        this.paper.transformToFitContent({ verticalAlign: 'middle', horizontalAlign: 'middle', maxScale: 2 });
    }
}

export function createFlowPreview(options) {
    try {
        const graphJson = JSON.parse(options.graphJson);
        return new FlowPreview(options);
    } catch (error) {
        console.error('Invalid JSON input', error);
        console.error('Options:', options);
    }
}
